import IdentityVerification from './IdentityVerification'

export default IdentityVerification